// en.js
const en = {
  Address: 'Address',
  Email: 'Email',
  Fax: 'Fax',
  ViewMore: 'View More',
  ViewDetails: 'View',
  ViewAll: 'View All',
  View: 'View',
  Home: 'Home',
  News: 'News',
  CorrelationNews: 'Correlation News',
  OrganizationalProfile: 'About US',
  FoundationProject: 'Project',
  SpecialFund: 'Special Fund',
  KidsGallery: 'Kids art gallery',
  Download: 'Download',
  ContactUs: 'Contact Us',
  PleaseInput: 'Please Input',
  FoundingSupportingInstitutionsFoundation:
    'Founding Supporting Institutions of the Foundation',
  CouncilMembers: 'Board Member',
  FollowWeChatAccount: 'Follow the official WeChat account',
  FollowWeiboAccount: 'Follow the official Weibo account',
  FoundationIntroduction: 'Samaranch',
  FoundingDirectorUnit: 'Founding Partners',
  Council: 'Board information',
  OrganizationStructure: 'Organization Structure',
  PreviousArticle: 'Previous Article',
  NextArticle: 'Next Article',
  noArticle:'No more',
  FoundationPurpose: 'Foundation Purpose',
  FoundingInstitutionsFoundation:
    'Founding Member',
  CouncilMember: 'Board Member',
  FundIntroduction: 'Fund Introduction',
  NewsInformation: 'News and Information',
  Share: 'Share',
  Foreword: 'Foreword',
  Jury: 'Jury',
  PrimaryGroup: 'Primary School Group',
  MiddleGroup: 'Middle School Group',
  Author: 'Author',
};
export default en;
